import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "../../imports/muiImport";

import { useLocation, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import DesktopProductCardsList from "./LARGEDEVICE/DesktopProductList";
import DesktopProductFilter from "./LARGEDEVICE/ProductFilter";

import { getAllProducts } from "../../imports/generalImport";

import AllCategoryBanner from "./LARGEDEVICE/AllCategoryBanner";
import ProductFilterMobile from "./MEDIUMDEVICE/mobileProductFilter";
import {
  rearrangedProducts,
  rearrangedProductHandler,
} from "./mobileAllGiftCardPage";
import ProductlistPagination from "../../components/pagination/productlist-pagination";

const AllGiftCardPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchItem = useLocation();
  const canonicalUrl = `https://www.99gift.ae/${searchItem.pathname}`;

  const categorySlug =
    searchParams
      .get("categorySlug")
      ?.split(/[+\s]+/)
      .map((s) => decodeURIComponent(s))
      .filter(Boolean) || [];

  // Resolve SLUGS -> UUIDs (for the rearranger)
  const categoryIds = categorySlug
    .map(
      (slug) =>
        rearrangedProducts?.categories?.find((c) => c.slug === slug)?.id
    )
    .filter(Boolean);

  const brandIds =
    searchParams.get("brandIds")?.split(",").filter(Boolean) || [];
  const minPlatformAmount = searchParams.get("minPlatformAmount") || "";
  const maxPlatformAmount = searchParams.get("maxPlatformAmount") || "";

  return (
    <>
      <Helmet>
        <title>Explore the Best Gift Cards</title>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {/* Products */}
      <Container
        maxWidth="xl"
        sx={{
          px: {
            xs: 0,
            sm: 2,
            md: 0,
          },
          py: 2,
        }}
      >
        <Box
          sx={{
            display: {
              xs: "block",
              md: "none",
            },
            overflowX: "auto",
            whiteSpace: "nowrap",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <ProductFilterMobile
            categorySlugs={categorySlug}
            setSearchParams={setSearchParams}
          />
        </Box>

        <Grid container spacing={3} id="target-section">
          <Grid
            item
            sx={{
              display: {
                xs: "none",
                md: "block",
              },
              width: 240,
              flexShrink: 0,
              position: "sticky",
              top: "60px",
              height: "fit-content",
              paddingLeft: "0 !important",
              ml: 1.5,
            }}
          >
            <DesktopProductFilter
              categorySlug={categorySlug}
              brandIds={brandIds}
              minPlatformAmount={minPlatformAmount}
              maxPlatformAmount={maxPlatformAmount}
              setSearchParams={setSearchParams}
            />
          </Grid>

          {/* Product List */}
          <Grid item xs>
            <Box
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                mb: { xs: 2, sm: 4 },
                mt: { xs: 1, sm: 2, md: 5 },
                mr: { xs: 0, sm: 2, md: 3 },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { sm: "20px", md: "24px" },
                  color: "dark.main",
                  fontFamily: "Be Vietnam Pro",
                  lineHeight: 1.2,
                }}
              >
                All Gift Cards
              </Typography>
            </Box>

            <AllCategoryBanner />
            <DesktopProductCardsList products={products} loading={loading} />

            <ProductlistPagination
              fetchFunction={getAllProducts}
              limit={1000}
              basePayload={{
                categorySlug,
                categoryIds,
                brandIds,
                minPlatformAmount,
                maxPlatformAmount,
              }}
              dependency={[searchParams]}
              onLoadingChange={setLoading}
              onDataChange={setProducts}
              rearrangedProductHandler={rearrangedProductHandler}
              responseMapper={(response) => ({
                data: response?.data?.edges,
                totalCount: response?.data?.totalCount,
                hasNextPage: response?.data?.pageInfo?.hasNextPage,
                endCursor: response?.data?.pageInfo?.endCursor,
              })}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AllGiftCardPage;